import { ComponentProps, FC } from 'react';
import { Button } from 'antd';
import closeGray from 'assets/icons/close-gray.svg';
import { clsx } from 'clsx';
import { styled } from 'styled-components';

const StyledButton = styled(Button)`
  border-radius: 50px;
  & .ant-btn-icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &:hover {
    transform: scale(0.95);
    background-color: rgba(18, 18, 18, 0.06);
  }
`;

export const ClearButton: FC<ComponentProps<typeof Button>> = ({
  onClick,
  className,
  style,
}) => {
  return (
    <StyledButton
      type="text"
      onClick={onClick}
      style={style}
      icon={
        <img
          src={closeGray}
          alt="close"
          className={clsx(className)}
          style={style}
        />
      }
    />
  );
};
